import { useEffect, useState } from 'react';

export type ViewportMode = {
  width: number;
  isMobile: boolean;
  isTablet: boolean;
  isNarrowTablet: boolean;
  isDesktop: boolean;
};

function read(): ViewportMode {
  const width = typeof window !== 'undefined' ? window.innerWidth : 1280;
  const isMobile = width < 600;
  const isTablet = width >= 600 && width < 1024;
  const isNarrowTablet = width >= 600 && width < 900;
  const isDesktop = width >= 1024;
  return { width, isMobile, isTablet, isNarrowTablet, isDesktop };
}

/** Breakpoints alignés sur le plan UX V2. */
export function useViewportMode(): ViewportMode {
  const [mode, setMode] = useState<ViewportMode>(() => read());
  useEffect(() => {
    const onResize = () => setMode(read());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return mode;
}
